$(document).ready(function() {
    const mobileMenuBreakpoint = 1200;
    const $win = $(window);
    const $body = $('body');
    const $html = $('html');

    const $header = $('.site-header');
    const $headerMenu = $('#menu-main-menu');
    const $headerNav = $('.site-header .header-main-menu');
    const $headerTopNav = $('.site-header .header-top-menu');

    function NavigateMobileSubMenu(level, $subMenu) {
        $subMenu = $subMenu || null;
        if($subMenu) {
            $('.level-1').removeClass('active');
            $subMenu.addClass('active');
        }
        $headerMenu.css('transform', 'translate(' + (-100 * level) + '%)');
        $headerNav.attr('data-currentlevel', level);
    }

    $('.site-header .sub-menu-back').click(function () {
        const level = $(this).attr('data-backlevel');
        NavigateMobileSubMenu(level);
    });

    $('.site-header .menu-item-has-children').each(function (){
        const $self = $(this);
    const $link = $self.find('> a');
    const $subMenu = $self.find('> .sub-menu');
    const $subMenuBack = $subMenu.find('> .sub-menu__back');

    const linkHref = $link.attr('href');

    if(linkHref !== '#' && linkHref !== '' && linkHref !== undefined) {
        const $menuItemDuplicate = $('<li class="menu-item menu-item--duplicate"></li>');
        $link.clone().appendTo($menuItemDuplicate);
        $subMenuBack.after($menuItemDuplicate);
    }

        $link.click(function (event) {
                // Mobile behavior
            if($win.width() <= mobileMenuBreakpoint) {
                event.preventDefault();
                // Update the back button text with the parent menu item text
                const parentText = $link.text().trim();
                const $backButton = $subMenu.find("> .sub-menu__back .sub-menu-back");
                if ($backButton.length && parentText) {
                    $backButton.text(parentText);
                }
                NavigateMobileSubMenu($subMenu.attr('data-level'), $subMenu);
        } 
            // Desktop behavior - toggle dropdown on click
            else {
                event.preventDefault();
            
                // Toggle dropdown classes
                if (!$subMenu.hasClass('submenu-active')) {
                    // Remove active class from all other submenus
                    $('.site-header .menu-item-has-children').removeClass('dropdown-active');
                    $('.site-header .sub-menu').removeClass('submenu-active');
                    
                    // Add active class to this submenu
                    $self.addClass('dropdown-active');
                    
                    // Add submenu-active class with a slight delay for smooth transition
                    setTimeout(function() {
                        $subMenu.addClass('submenu-active');
                    }, 10);
                } else {
                    // Hide this submenu
                    $self.removeClass('dropdown-active');
                    $subMenu.removeClass('submenu-active');
                }
        }
    });
});

$('.mobile-close, .mobile-menu-toggle, .close-menu').click(function () {
    $headerNav.toggleClass('open');
    $headerTopNav.toggleClass('open');
    $body.toggleClass('no-scroll');
    $html.toggleClass('no-scroll');
    $("#mobile-menu-toggle").toggleClass("is-active");
    if ($html.hasClass("open")) {
    $win.scrollTop(0);
    }
});

// Close submenus when clicking outside
$(document).on('click', function(event) {
    if($win.width() > mobileMenuBreakpoint) {
        if(!$(event.target).closest('.menu-item-has-children').length) {
            // Close all dropdowns when clicking outside
            $('.site-header .menu-item-has-children').removeClass('dropdown-active');
            $('.site-header .sub-menu').removeClass('submenu-active');
        }
    }
});

// Reapply dropdown behavior on window resize
$win.on('resize', function() {
    if ($win.width() > mobileMenuBreakpoint) {
        // Close all dropdowns on resize
        $('.site-header .menu-item-has-children').removeClass('dropdown-active');
        $('.site-header .sub-menu').removeClass('submenu-active');
    }
});

    // Add header height as css var.
    function setMenuHeightVar() {
        $body.css('--header-height', $header.innerHeight() + 'px');
    }

    // Do this on page load
    setMenuHeightVar();

    // Do this on resize
    window.addEventListener('resize', event => {
        setMenuHeightVar();
    });
});
